<template>
  <div>
    <div class="title">余额充值？</div>
    <div class="content-info">
      <p class="txt1">进入“我的”界面，点击“我的钱包”模块中的“余额”，进入后点击“充值”按钮，输入充值金额即可通过支付宝或微信完成充值。</p>
      <ul>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/35f12f75ebb1478699bb317799a696fe.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/c79a8572bc860fffa657e1012bc60cd8.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/6c77a625a0683fe9c940f65f4bd8783a.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/dcb433bd13298d8f0056c76c9a6b5df6.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
